import {useSelector, shallowEqual} from 'react-redux';
import HeaderWithAuth from '@jobseeker/feature-navigation/widgets/HeaderAuth';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

import type {AppState} from '@jobseeker/common-core/types';

type HeaderAuthHarnessProps = {
  showHiristPromotionBanner: boolean;
};

const HeaderAuthHarness = ({showHiristPromotionBanner}: HeaderAuthHarnessProps) => {
  const interceptor: any = useInterceptor();
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const isUserLogin: boolean = useSelector(
    (state: AppState) => state.auth.isLoggedIn,
    shallowEqual
  );

  const {
    siteName,
    header: {config, meta},
    proMembership,
  } = interceptor;

  return (
    <HeaderWithAuth
      siteName={siteName}
      config={config}
      meta={meta}
      isLoggedIn={isUserLogin}
      page={page}
      subscriptionMeta={proMembership}
      showHiristPromotionBanner={showHiristPromotionBanner}
    />
  );
};

export default HeaderAuthHarness;
